import MobileNav from "./MobileNav";
import NavbarDD from "./NavbarDD";

const HeaderDD = () => {
  return (
    <header>
      <div className="nav-area">

        {/* for large screens */}
        <NavbarDD />

        {/* for small screens */}
        <MobileNav />
      </div>
    </header>
  );
};

export default HeaderDD;